(ns quuppa.qsm.register-qpe.utils
  (:require [clojure.string :as str]))

(defn make-docker-run-command [qsm-endpoint installation-token proxy-host proxy-port]
  (let [proxy-defined? (and (seq proxy-host)
                            (seq proxy-port))
        args ["docker run"
              "--pull always"
              "--name qpe"
              "--detach"
              "--network host"
              "-p 3000:3000"
              ; UDP 22104 Unidirectional | Quuppa Data Player advertise | QPE -> QDP | Broadcast | Encrypted
              "-p 22114:22114/udp"
              ; TCP 22106 Bidirectional | Quuppa Data Player data | QPE/QDP -> QDP/QPE | Unicast | Encrypted
              "-p 22116:22116"
              ; UDP 22100 Unidirectional | Requests to Focusing Locator | QSP -> Locator | Unicast | Encrypted
              "-p 22100:22100/udp"
              ; UDP 22107 Unidirectional | Quuppa System Simulator data | QSP -> QPE | Unicast | Encrypted
              "-p 22107:22107/udp"
              ; limit container disk size so that filespace of the host machine wouldn't run out
              ; This will only work on fs that supports quota (e.g. zfs, btrfs)
              ; It seems it's possible to specify fstype with options, but let's test this properly before putting it
              ; in as standard option (see https://stackoverflow.com/questions/40494536/how-to-specify-the-size-of-a-shared-docker-volume)
              ; "--storage-opt size=120G"
              "--volume qpe-data:/data"
              "--restart unless-stopped"
              (when proxy-defined?
                (str "-e PROXY_HOST=" proxy-host))
              (when proxy-defined?
                (str "-e PROXY_PORT=" proxy-port))
              "quuppa/qpe-boot:latest"
              (str "--qsm-endpoint " qsm-endpoint)
              (str "--installation-token " installation-token)]
        ;; Allow using nil values for optional parts
        args (remove nil? args)]
    (str/join " " args)))
